import * as Joi from 'joi';
import {
  getEmailSchema,
  getJoiObject,
  getMasterCodeObjectDropdownSchema,
  getPhoneNumberSchema,
  validateNRIC,
  validateSingaporeCountry,
} from '../../../utils/JoiUtils';
import { IExamMasterCodeItem, LookupListApiItem } from '../../../api/user/model';
import { Dayjs } from 'dayjs';

export interface CreateEditAdminSchemaData {
  name?: string;
  nricFinPassport?: string;
  dateOfBirth?: string;
  email?: string;
  mobileCountryCode?: IExamMasterCodeItem;
  mobileContactNumber?: string;
  action?: LookupListApiItem;
  approver?: LookupListApiItem;
  remarks?: string;
  accountType?: string;
  userGroup?: [];
  expiryDate?: string;
}

export type AdminProfileResponseIsDisableInputs = {
  [P in keyof CreateEditAdminSchemaData]?: boolean;
};

const CreateEditAdminSchema = (isDisableInputs?: AdminProfileResponseIsDisableInputs) =>
  Joi.object<CreateEditAdminSchemaData>({
    name: Joi.string().required().max(66).messages({
      'any.required': 'Name is not allowed to be empty',
      'string.empty': 'Name is not allowed to be empty',
      'string.max': 'Name is too long',
    }),
    nricFinPassport: getJoiObject(
      Joi.when('accountType', {
        is: 'SINGPASS',
        then: Joi.string()
          .alphanum()
          .required()
          .max(20)
          .custom(validateNRIC, 'Validate NRIC / FIN  ')
          .messages({
            'any.required': `NRIC / FIN is not allowed to be empty`,
            'string.empty': `NRIC / FIN is not allowed to be empty`,
            'string.alphanum': `NRIC / FIN should be alphanumeric`,
            'string.max': 'NRIC / FIN is too long',
            'string.pattern.nric': 'Invalid NRIC',
            'string.pattern.fin': 'Invalid FIN',
            'string.pattern.startCharError':
              'Invalid NRIC / FIN i.e. must start with S, T, F, G or M',
          }),
        otherwise: Joi.string().allow(''),
      }),
      isDisableInputs?.nricFinPassport
    ),
    dateOfBirth: getJoiObject(
      Joi.string().required().messages({
        'any.required': 'Date of birth is not allowed to be empty',
        'string.empty': 'Date of birth is not allowed to be empty',
      }),
      isDisableInputs?.dateOfBirth
    ),
    email: getEmailSchema('Email'),
    mobileCountryCode: getJoiObject(getMasterCodeObjectDropdownSchema(false, 'Country code')),
    mobileContactNumber: Joi.when('mobileCountryCode', {
      is: validateSingaporeCountry,
      then: getPhoneNumberSchema(false, 'Mobile No.', 8, 8),
      otherwise: getPhoneNumberSchema(false, 'Mobile No.'),
    }),
    action: getJoiObject(
      Joi.required().messages({
        'any.required': 'Action is required',
      }),
      isDisableInputs?.action
    ),
    approver: getJoiObject(
      Joi.any().required().messages({
        'any.required': 'Please select Approver.',
      }),
      isDisableInputs?.approver
    ),
    remarks: getJoiObject(
      Joi.string().required().trim().min(1).messages({}),
      isDisableInputs?.remarks
    ),
    accountType: Joi.string().allow(''),
    userGroup: Joi.array().items(
      Joi.object({
        id: Joi.number(),
        displayName: Joi.string(),
      }).allow(null)
    ),
    expiryDate: getJoiObject(Joi.string().allow(''), isDisableInputs?.expiryDate),
  });

export default CreateEditAdminSchema;
